import {
  ScriptType,
  ScriptMetadata,
  assignType,
  assignHash
} from "./ScriptMetadata";

export type ScriptFunction = (script: HTMLScriptElement) => void;

export class ScriptBuilder {
  private metadata: ScriptMetadata = {} as ScriptMetadata;
  private async = true;
  private defer = true;
  private fn: ScriptFunction = script => {};

  withType(type: ScriptType): ScriptBuilder {
    this.metadata.type = type;
    return this;
  }

  withId(id: string): ScriptBuilder {
    this.metadata.id = id;
    return this;
  }

  withSource(source: string): ScriptBuilder {
    this.metadata.source = source;
    return this;
  }

  withMetadata(metadata: ScriptMetadata): ScriptBuilder {
    this.metadata = metadata;
    return this;
  }

  withAsync(async = true): ScriptBuilder {
    this.async = async;
    return this;
  }

  withDefer(defer = true): ScriptBuilder {
    this.defer = defer;
    return this;
  }

  with(fn: ScriptFunction = script => {}): ScriptBuilder {
    this.fn = fn;
    return this;
  }

  build(): HTMLScriptElement {
    if (!this.metadata.type) {
      throw new Error("Cannot build script without a type");
    }
    if (!this.metadata.id) {
      throw new Error("Cannot build script without an id");
    }
    if (!this.metadata.source) {
      throw new Error("Cannot build script without a source location");
    }
    const script = document.createElement("script");
    script.id = this.metadata.id;
    assignType(script, this.metadata.type);
    assignHash(script, this.metadata);
    script.async = this.async;
    script.defer = this.defer;
    this.fn(script);
    script.src = this.metadata.source;
    return script;
  }

  static builder(): ScriptBuilder {
    return new ScriptBuilder();
  }
}
